// @ts-nocheck
import {Column} from 'react-table'
import {UserCustomHeader} from '../apps/user-management/users-list/table/columns/UserCustomHeader'
import {ProfitabilityRecord} from './api'

const getProfitabilityColumns = (): ReadonlyArray<Column<ProfitabilityRecord>> => [
  {
    Header: (props) => (
      <UserCustomHeader
        tableProps={props}
        title='Product'
        className='min-w-150px ps-4 text-center'
      />
    ),
    id: 'productName',
    accessor: 'productName',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='SKU Code' className='min-w-100px text-center' />
    ),
    accessor: 'skuCode',
    sortType: 'alphanumeric',
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Revenue' className='min-w-125px text-center' />
    ),
    accessor: 'revenue',
    sortType: 'basic',
    Cell: ({...props}) => <div>&#8377; {props.data[props.row.index].revenue}</div>,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Cost' className='min-w-125px text-center' />
    ),
    accessor: 'cost',
    sortType: 'basic',
    Cell: ({...props}) => <div>&#8377; {props.data[props.row.index].cost}</div>,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Profit' className='min-w-125px text-center' />
    ),
    accessor: 'profit',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='text-success fw-bold'>&#8377; {props.data[props.row.index].profit}</span>
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Margin %' className='min-w-100px text-center' />
    ),
    accessor: 'margin',
    sortType: 'basic',
    Cell: ({...props}) => (
      <span className='badge badge-light-success text-success fw-bold'>
        {props.data[props.row.index].margin}%
      </span>
    ),
  },
]

export {getProfitabilityColumns}
